import axios from 'axios';
import Cookies from 'js-cookie';

axios.interceptors.request.use(
  (config) => {
    const credentialsEnv = import.meta.env.VITE_APP_CREDENTIALS;
    const credentials = Cookies.get(credentialsEnv);
    if (credentials) {
      config.headers['Authorization'] = `Bearer ${credentials}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);
